import React from 'react';
import {Auth, I18n} from 'aws-amplify';
import {RequireNewPassword,} from 'aws-amplify-react';
import {Input} from 'aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React';

import axiosBase from 'axios';
import APP_ENV from "../Environment";
import {RequireNewPasswordComponent} from "../Components/RequireNewPasswordComponent";
import TranslateError from "../translate/TranslateError";

export default class NewRequestPassword extends RequireNewPassword {

    createNewPassword(user, new_password, attrs) {
        Auth.completeNewPassword(user, new_password, attrs)
            .then(user => {
                console.warn('complete new password', user);
                if (user.challengeName === 'SMS_MFA') {
                    this.changeState('confirmSignIn', user);
                } else if (user.challengeName === 'MFA_SETUP') {
                    console.warn('TOTP setup', user.challengeParam);
                    this.changeState('TOTPSetup', user);
                } else {
                    // ↓ update library
                    console.warn("userBFF前",user.signInUserSession);
                    const axios = axiosBase.create({
                        baseURL: APP_ENV.BFF, // バックエンドB のURL:port を指定する
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': `Bearer ${user.signInUserSession.idToken.jwtToken}`
                        },
                        responseType: 'json'
                    });

                    axios.put(APP_ENV.BFF + "/user", {customer_id: user.signInUserSession.idToken.payload["custom:ecc_customer_id"],password: new_password, sub: user.signInUserSession.idToken.jwtToken})
                        .then((res) => {
                            // 更新成功画面を表示
                            this.changeState('CompChangePass', user);
                        })
                        .catch((e) => this.error(TranslateError(e)))
                    return;
                    // ↑ update library
                }
            })
            .catch(err => this.error(TranslateError(err)));
    }
    // ↓ update library
    change() {
        const user = this.props.authData;
        const {old_password, new_password, new_password_confirm} = this.inputs;
        const {requiredAttributes} = user.challengeParam;
        const attrs = objectWithProperties({new_password}, requiredAttributes);

        let err = this.IsInput(old_password, new_password, new_password_confirm);

        if (err !== '') {
            this.error(err);
        }
        if (!Auth || typeof Auth.completeNewPassword !== 'function') {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        this.createNewPassword(user, new_password, attrs);
        return;
    }

    IsInput(old_password, new_password, new_password_confirm) {
        let err = "";

        const isEmptyInput = () => {
            let err = "";
            err += !old_password ? "OldPassword " : "";
            err += !new_password ? "NewPassword " : "";
            err += !new_password_confirm ? "NewPasswordConfirm " : "";
            if (err !== '') {
                err += 'cannot be empty';
            }

            return err;
        };
        const isOldNewPassConfirm = () => {
            let err = "";
            if (old_password === new_password) {
                err += "NewPassword is same OldPassword";
            }
            return err;
        };
        const isNewPassConfirm = () => {
            let err = "";
            if (new_password !== new_password_confirm) {
                err += "NewPassword is different NewPasswordConfirm";
            }
            return err;
        };

        err += isEmptyInput();
        if (err === '') {
            err += isOldNewPassConfirm();
        }
        if (err === '') {
            err += isNewPassConfirm();
        }
        return err;
    }
    showComponent(theme) {
        const user = this.props.authData;
        const {requiredAttributes} = user.challengeParam;

        return (
            <RequireNewPasswordComponent theme={theme} newRequestPassword={this} map={requiredAttributes
                .map(attribute => (
                    <Input
                        placeholder={I18n.get(convertToPlaceholder(attribute))}
                        theme={theme}
                        key={attribute}
                        name={attribute}
                        type="text"
                        onChange={this.handleInputChange}
                    />
                ))} change={this.change} changeStateFunc={() => this.changeState('signIn')}/>
        )
    }
}
// ↑ update library

const convertToPlaceholder = (str) => {
    return str.split('_').map(part => part.charAt(0).toUpperCase() + part.substr(1).toLowerCase()).join(' ')
};

const objectWithProperties = (obj, keys) => {
    const target = {};
    for (const key in obj) {
        if (keys.indexOf(key) === -1) {
            continue;
        }
        if (!Object.prototype.hasOwnProperty.call(obj, key)) {
            continue;
        }
        target[key] = obj[key];
    }
    return target;
};